// extracted by mini-css-extract-plugin
export default {"container":"System_container__zd26Z"};